import apiClient from '@/api/client';

export const DeviceService = {
    async getUploadOptions(): Promise<DeviceUploadOptionsResponse> {
        const response = await apiClient.get<DeviceUploadOptionsResponse>('/devices/upload-options');
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to get upload device options.');
        }

        return result;
    },

    async bulkAllocateSims(csvContent: string): Promise<BulkAllocateSimsResponse> {
        const response = await apiClient.post<BulkAllocateSimsResponse>('/devices/bulk-allocate-sims', {
            csvContent: csvContent
        });
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to allocate sims to devices.');
        }

        return result;
    },

    async bulkCreate(csvContent: string): Promise<BulkUploadDevicesResponse> {
        const response = await apiClient.post<BulkUploadDevicesResponse>('/devices/bulk-upload', {
            csvContent: csvContent
        });
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to upload devices.');
        }

        return result;
    }
}

export interface BulkUploadDevicesResponse {
    success: boolean
    totalRows: number
    errorMessage?: string | null
    failedRow: number
}

export interface DeviceUploadOptionsResponse {
    partners: string[]
    deviceTypes: string[]
    simProviders: string[]
}

export interface BulkAllocateSimsResponse {
    success: boolean
    totalRows: number
    errorMessage?: string
    failedRow: number
}
  
